import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-769fa3a2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "investigation-type-audit-trail-modal" }

export function render(_ctx, _cache) {
  const _component_AuditTrailModal = _resolveComponent("AuditTrailModal")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_AuditTrailModal, {
      applicationName: _ctx.investigationName,
      applicationTypeName: 'Investigation types',
      auditTrailData: _ctx.auditTrail,
      loadingContent: _ctx.loadingContent,
      errorLoadingContent: _ctx.errorLoadingContent,
      onCloseAuditTrailModal: _cache[0] || (_cache[0] = $event => (_ctx.closeModal()))
    }, null, 8, ["applicationName", "auditTrailData", "loadingContent", "errorLoadingContent"])
  ]))
}